import { render, staticRenderFns } from "./DiscordLink.vue?vue&type=template&id=2b6c8648&"
import script from "./DiscordLink.vue?vue&type=script&lang=js&"
export * from "./DiscordLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports